export default __webpack_public_path__ + "static/media/back_1.ca13060c.jpg";